import React from 'react'
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

import { $createTextVariableNode } from 'components/shared/FormFields/common/Editors/nodes/TextVariableNode/TextVariableNode'
import { splitTemplate } from 'components/shared/FormFields/common/Editors/model'

export const InitialStatePlugin = ({ value, variables }) => {
  const [editor] = useLexicalComposerContext()

  const isInitialLoad = React.useRef(true)

  React.useEffect(() => {
    editor.update(() => {
      const root = $getRoot()

      if (!value || isInitialLoad.current === false) {
        return
      }

      if (value) {
        isInitialLoad.current = false
        root.clear()
      }

      const paragraph = $createParagraphNode()

      for (const chunk of splitTemplate(value, variables)) {
        paragraph.append(
          chunk.type === 'variable'
            ? $createTextVariableNode(chunk.key, chunk.label)
            : $createTextNode(chunk.text),
        )
        root.append(paragraph)
      }
    })
  }, [editor, value, variables, isInitialLoad])

  React.useEffect(() => {
    return () => {
      editor.update(() => {
        const root = $getRoot()
        root.clear()
      })
    }
  }, [editor])

  return null
}
